const isBrowser = typeof window !== 'undefined';
const getGtag = (): ((...args: any[]) => void) | undefined => {
  try {
    return isBrowser ? (window as any).gtag : undefined;
  } catch {
    return undefined;
  }
};

// En SPA, gtag('config') est injecté dans index.html avec send_page_view: false
// Nous envoyons manuellement les vues de pages lors des changements de route.
export const trackPageView = (path: string) => {
  try {
    const gtag = getGtag();
    if (!gtag) return;
    gtag('event', 'page_view', {
      page_path: path || window.location.pathname,
      page_title: document?.title,
      page_location: window.location.href,
    });
  } catch (_) {
    // Ne pas casser l'app si GA n'est pas dispo
  }
};

export const trackEvent = (eventName: string, eventParams: Record<string, any> = {}) => {
  try {
    const gtag = getGtag();
    if (!gtag) return;
    gtag('event', eventName, eventParams);
  } catch (_) {
    // noop
  }
};

export const trackError = (error: Error, errorContext: Record<string, any> = {}) => {
  try {
    const gtag = getGtag();
    if (gtag) {
      gtag('event', 'exception', {
        description: error?.message || 'Unknown error',
        fatal: false,
        ...errorContext,
      });
    }
  } finally {
    // Garder la journalisation des erreurs dans la console
    if (typeof console !== 'undefined') console.error(error);
  }
};
